import axios from "axios";
import createPublicApiInstance from '../api';

export async function getCurrentAccount(id,authToken) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const response = await apiInstance.get(`/movimiento-cuenta-corriente/${id}?authToken=${authToken}`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getAccountSearch(id, dates) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const body = {
			fecha_hasta: dates.finish_date,
			afiliado_id: id,
			fecha_desde: dates.initial_date
		}

		const response = await apiInstance.post(`/movimiento-cuenta-corriente/search`,body);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getPaysDebtFromSisad(id) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const response = await apiInstance.get(`/pendientes-pago/${id}`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getPendingPaymentRequestsFromSisad(id) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const response = await apiInstance.get(`/pago-solicitud/pendientes/${id}`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getPaymentStatusFromSisad(id) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const response = await apiInstance.get(`/pago/consultar-estado/${id}`);
		return response.data
	} catch (error) {
		return { error }
	}
}

// export async function requestMockedQr() {
// 	try {
// 		//const response = await axios.get(`${process.env.REACT_APP_MOCKED_QR_API}`);
// 		const response = await fetch(`${process.env.REACT_APP_MOCKED_QR_API}`);
 
// 		return response
// 	} catch (error) {
// 		return { error }
// 	}
// }

export async function createQrPaymentOrder(body) {

	// const basicAuth = `cXJVc2VyU2FuZGJveDpiN1hacEtjQUVuNXRXVnUzNEZRbw==`
	const basicAuth = process.env.REACT_APP_PAY_BASE64_CREDENTIALS
	try {

		const response = await axios.post(`${process.env.REACT_APP_PAY_QR_API}`, body,
			{
				headers: {
					'Authorization': `Basic ${basicAuth}`,
					'Content-Type': 'application/json' 
				}
			}
		);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function createRefundFromPendingResquests(body) {

	try {
		const apiInstance = createPublicApiInstance();
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}

		const response = await apiInstance.post(`/pago-solicitud/crearReintegroAPartirDeSolicitudes`, body);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function computeBalancePayment(body) {

	try {
		const apiInstance = createPublicApiInstance();
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}

		const response = await apiInstance.post(`/pago-solicitud/pagarConSaldo`, body);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function createPay(body) {
	try {
		const response = await axios.post(`${process.env.REACT_APP_DANSUAPI}/private/pago`, body);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function createPendingPayonSisad(body) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const response = await apiInstance.post(`/pago/crear-pendiente`,body);

		return response.data
	} catch (error) {
		return { error }
	}
}

export async function createPendingPayFromPaymentRequestOnSisad(body) {
	try {
		const apiInstance = createPublicApiInstance(); 
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}
		
		const response = await apiInstance.post(`/pago-solicitud/crear-pago-pendiente`,body);

		return response.data
	} catch (error) {
		return { error }
	}
}